var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { featureFlagClientInit, FeatureFlagUserBuilder } from '@raisin/feature-flag-react-client';
import { getLocale, LAUNCH_DARKLY_CLIENT_SIDE_IDS } from '../../constants';
import { getEnvironment, getLocalePathFromHost, getRegionFromHost } from '../domain';
export const getDefaultFFBuilderParams = () => {
    var _a, _b;
    const localePath = getLocalePathFromHost();
    return {
        isAlphaGroup: false,
        isBetaGroup: false,
        investorType: '',
        distributor: '',
        investorStatus: '',
        investorCountry: localePath ? (_b = (_a = getLocale(localePath)) === null || _a === void 0 ? void 0 : _a.iso3) === null || _b === void 0 ? void 0 : _b.toUpperCase() : '',
        customerId: undefined,
    };
};
export const getLaunchDarklyClientSideId = () => {
    const namespace = getEnvironment();
    return LAUNCH_DARKLY_CLIENT_SIDE_IDS[namespace] || LAUNCH_DARKLY_CLIENT_SIDE_IDS.development;
};
export const buildFeatureFlagUser = ({ customerId, investorCountry, investorStatus, investorType, isAlphaGroup, isBetaGroup, distributor, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return new FeatureFlagUserBuilder(customerId)
            .investorType(investorType)
            .investorStatus(investorStatus)
            .distributor(distributor)
            .investorDomain(investorCountry)
            .country(investorCountry)
            .alphaInvestor(isAlphaGroup)
            .betaInvestor(isBetaGroup)
            .investorRegion(getRegionFromHost())
            .build();
    }
    catch (error) {
        throw new Error();
    }
});
export const getLdClientWithoutCustomerTarget = (targetProperties) => __awaiter(void 0, void 0, void 0, function* () {
    return featureFlagClientInit(getLaunchDarklyClientSideId(), yield buildFeatureFlagUser(Object.assign(Object.assign({}, getDefaultFFBuilderParams()), targetProperties)), { streaming: true });
});
//# sourceMappingURL=clientBaseConfig.js.map